import DavichiForm from '~/events/2021/03/event-davichi-slider/davichi-form';
import * as React from 'react';
export default {
  DavichiForm,
  React
};